import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
} from '@backstage/core-plugin-api';

import {
  createRootRouteRefsPair,
  createSubRouteRefsPair,
} from '@spotify/confidence-core-react';

export enum RoutesIds {
  explore = 'explore',
  conversation = 'conversation',
}

// root route
export const [exploreRouteImplRef, exploreRouteRef] = createRootRouteRefsPair({
  id: RoutesIds.explore,
});

export const rootRouteRef = exploreRouteImplRef;

// sub-routes within the plugin
export const [conversationRouteImplRef, conversationRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.conversation,
    parent: rootRouteRef,
    path: '/:conversationId',
  });

// default routes/routes to be used by other plugins
export const Routes = {
  explore: exploreRouteImplRef,
  conversation: conversationRouteImplRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // sub-routes within the plugin
  explore: exploreRouteRef,
  conversation: conversationRouteRef,
} satisfies Record<RoutesIds, ExternalRouteRef>;
